// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  height: 45px !important;
  width: 100vw;
  color: var(--color-black-light);
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 1vw;
  position: fixed;
  bottom: 0;
  background: var(--color-blue-0-light);
}

.left-slot {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.left-slot ion-icon {
  color: var(--color-black-light);
  cursor: pointer;
}

.right-slot {
  display: flex;
  align-items: center;
  margin-right: 1vw;
}

.spacer {
  flex-grow: 1;
}

ion-item {
  z-index: 1000;
}

.mood-toggle {
  width: 3.4375rem;
  height: 1.875rem;
  --handle-width: 1.625rem;
  --handle-height: 1.625rem;
  --handle-spacing: .125rem;
  --background: url(/assets/img/moodLight.png) center/55px 30px;
  --background-checked: url(/assets/img/moodDark.png) center/55px 30px;
  --handle-background: var(--color-blue-3-light);
}

.loc-pin {
  color: var(--color-blue-3-light);
}

.location {
  font-weight: 500;
}

/* dark theme styles */
.footer.dark {
  color: var(--color-black-dark);
  background: var(--color-blue-1-light);
}

.dark .left-slot ion-icon {
  color: var(--color-black-dark);
}
.dark .mood-toggle {
  --handle-background: var(--color-blue-3-dark);
}
.dark .loc-pin {
  color: var(--color-black-dark);
}`, "",{"version":3,"sources":["webpack://./src/app/components/footerbar/footerbar.component.scss","webpack://./../../../../../Ryan%20Ticer/source/repos/seacom3/ui/src/app/components/footerbar/footerbar.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,YAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,qCAAA;ACCF;;ADEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;ACCF;ADCE;EACE,+BAAA;EACA,eAAA;ACCJ;;ADGA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;ACAF;;ADGA;EACE,YAAA;ACAF;;ADGA;EACE,aAAA;ACAF;;ADGA;EACE,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,6DAAA;EACA,oEAAA;EACA,8CAAA;ACAF;;ADGA;EACE,gCAAA;ACAF;;ADGA;EACE,gBAAA;ACAF;;ADGA,sBAAA;AACA;EACE,8BAAA;EACA,qCAAA;ACAF;;ADKI;EACE,8BAAA;ACFN;ADME;EACE,6CAAA;ACJJ;ADOE;EACE,8BAAA;ACLJ","sourcesContent":[".footer {\r\n  height: 45px !important;\r\n  width: 100vw;\r\n  color: var(--color-black-light);\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  padding: 0 1vw;\r\n  position: fixed;\r\n  bottom: 0;\r\n  background: var(--color-blue-0-light);\r\n}\r\n\r\n.left-slot {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n\r\n  ion-icon {\r\n    color: var(--color-black-light);\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.right-slot {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-right: 1vw;\r\n}\r\n\r\n.spacer {\r\n  flex-grow: 1;\r\n}\r\n\r\nion-item {\r\n  z-index: 1000;\r\n}\r\n\r\n.mood-toggle {\r\n  width: 3.4375rem;\r\n  height: 1.875rem;\r\n  --handle-width: 1.625rem;\r\n  --handle-height: 1.625rem;\r\n  --handle-spacing: .125rem;\r\n  --background: url(/assets/img/moodLight.png) center/55px 30px;\r\n  --background-checked: url(/assets/img/moodDark.png) center/55px 30px;\r\n  --handle-background: var(--color-blue-3-light);\r\n}\r\n\r\n.loc-pin {\r\n  color: var(--color-blue-3-light);\r\n}\r\n\r\n.location {\r\n  font-weight: 500;\r\n}\r\n\r\n/* dark theme styles */\r\n.footer.dark {\r\n  color: var(--color-black-dark);\r\n  background: var(--color-blue-1-light);\r\n}\r\n\r\n.dark {\r\n  .left-slot {\r\n    ion-icon {\r\n      color: var(--color-black-dark);\r\n    }\r\n  }\r\n\r\n  .mood-toggle {\r\n    --handle-background: var(--color-blue-3-dark);\r\n  }\r\n\r\n  .loc-pin {\r\n    color: var(--color-black-dark);\r\n  }\r\n}\r\n",".footer {\n  height: 45px !important;\n  width: 100vw;\n  color: var(--color-black-light);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 1vw;\n  position: fixed;\n  bottom: 0;\n  background: var(--color-blue-0-light);\n}\n\n.left-slot {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.left-slot ion-icon {\n  color: var(--color-black-light);\n  cursor: pointer;\n}\n\n.right-slot {\n  display: flex;\n  align-items: center;\n  margin-right: 1vw;\n}\n\n.spacer {\n  flex-grow: 1;\n}\n\nion-item {\n  z-index: 1000;\n}\n\n.mood-toggle {\n  width: 3.4375rem;\n  height: 1.875rem;\n  --handle-width: 1.625rem;\n  --handle-height: 1.625rem;\n  --handle-spacing: .125rem;\n  --background: url(/assets/img/moodLight.png) center/55px 30px;\n  --background-checked: url(/assets/img/moodDark.png) center/55px 30px;\n  --handle-background: var(--color-blue-3-light);\n}\n\n.loc-pin {\n  color: var(--color-blue-3-light);\n}\n\n.location {\n  font-weight: 500;\n}\n\n/* dark theme styles */\n.footer.dark {\n  color: var(--color-black-dark);\n  background: var(--color-blue-1-light);\n}\n\n.dark .left-slot ion-icon {\n  color: var(--color-black-dark);\n}\n.dark .mood-toggle {\n  --handle-background: var(--color-blue-3-dark);\n}\n.dark .loc-pin {\n  color: var(--color-black-dark);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
